import { render, staticRenderFns } from "./WeddingDemoView.vue?vue&type=template&id=771fd1cb&scoped=true&"
import script from "./WeddingDemoView.vue?vue&type=script&lang=js&"
export * from "./WeddingDemoView.vue?vue&type=script&lang=js&"
import style0 from "./WeddingDemoView.vue?vue&type=style&index=0&id=771fd1cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771fd1cb",
  null
  
)

export default component.exports